import { EditorState } from "draft-js";

export const getSelectionInlineStyle = (editorState: EditorState): string[] | null => {
    const selection = editorState.getSelection();
    if (!selection.isCollapsed()) return null;

    const styleList = editorState.getCurrentInlineStyle().toList().toJS();
    return styleList;
};
